import { TypedDocumentNode, gql } from '@apollo/client';

import { useSportContext } from 'contexts/sport';
import { useQuery } from 'hooks/graphql/useQuery';
import { joinFiltersWithAnd } from 'lib/algolia';

import type {
  FootballCardsInLineupQuery,
  FootballCardsInLineupQueryVariables,
} from './__generated__/useNotInLineupFilterValue.graphql';

const FOOTBALL_QUERY = gql`
  query FootballCardsInLineupQuery($sport: Sport!) {
    currentUser {
      slug
      blockchainCardsInLineups(sport: $sport)
    }
  }
` as TypedDocumentNode<
  FootballCardsInLineupQuery,
  FootballCardsInLineupQueryVariables
>;

const toFilter = (slugs: string[] | undefined | null) => {
  if (!slugs?.length) return undefined;

  return `(${joinFiltersWithAnd(
    slugs.map(objectID => `NOT slug:"${objectID}"`)
  )}) AND NOT rarity:common`;
};

export const useNotInLineupFilterValue = ({ skip }: { skip: boolean }) => {
  const { sport } = useSportContext();
  const { data } = useQuery(FOOTBALL_QUERY, {
    skip,
    variables: { sport },
  });

  return toFilter(data?.currentUser?.blockchainCardsInLineups);
};
